import { Template } from "features/Influencer/ContactList/schema";

import {
  GamificationProfile,
  OrganizationGamificationCredit,
  OrganizationGamificationTask,
} from "./schema";

export const hasTaskByType = (
  gamificationProfile: GamificationProfile | null,
  taskType: OrganizationGamificationTask,
) => {
  if (!gamificationProfile || !gamificationProfile?.tasksCompleted)
    return false;
  return gamificationProfile.tasksCompleted?.some((task) => task === taskType);
};

export const countTaskByType = (
  gamificationProfile: GamificationProfile | null,
  taskType: OrganizationGamificationTask,
) => {
  if (!gamificationProfile || !gamificationProfile?.tasksCompleted) return 0;
  return gamificationProfile.tasksCompleted.filter((task) => task === taskType)
    .length;
};

export const countCreditByTask = (
  credits: OrganizationGamificationCredit[] | null,
  taskType: OrganizationGamificationTask,
) => {
  if (!credits) return 0;
  return credits.filter((task) => task.transactionType === taskType).length;
};

export const displayFirstTemplateCard = (
  outreachTemplates: Template[],
  gamificationProfile: GamificationProfile,
) => {
  if (
    countTaskByType(
      gamificationProfile,
      OrganizationGamificationTask.niche_templates,
    ) === 0
  ) {
    return true;
  }
  const sortedTemplatesByCreatedAt = outreachTemplates?.sort((a, b) => {
    if (!a.createdAt || !b.createdAt) return 0;
    return a.createdAt - b.createdAt;
  });

  const secondTemplate = sortedTemplatesByCreatedAt?.[1];
  if (
    !secondTemplate ||
    !secondTemplate?.createdAt ||
    !gamificationProfile ||
    !gamificationProfile?.createdAt
  )
    return false;
  return secondTemplate?.createdAt >= gamificationProfile?.createdAt;
};

export const displayFirstTemplateCardOnlyForVa = (
  gamificationProfile: GamificationProfile,
  credits: OrganizationGamificationCredit[] | null,
) => {
  return (
    countTaskByType(
      gamificationProfile,
      OrganizationGamificationTask.niche_templates,
    ) > countCreditByTask(credits, OrganizationGamificationTask.niche_templates)
  );
};

export const isTaskCompleted = (
  gamificationProfile: GamificationProfile | null,
  taskType: OrganizationGamificationTask,
  index: number,
) => {
  if (!gamificationProfile) return false;
  return countTaskByType(gamificationProfile, taskType) >= index;
};

export const getActiveStepForLevelOneFree = (
  gamificationProfile: GamificationProfile | null,
) => {
  if (!gamificationProfile || !gamificationProfile?.tasksCompleted) return 0;

  const tasksByOrder = [
    OrganizationGamificationTask.add_portfolio,
    OrganizationGamificationTask.add_template,
    OrganizationGamificationTask.add_followup,
    OrganizationGamificationTask.send_followup,
    OrganizationGamificationTask.send_pitch,
  ];
  let taskIndex = 0;
  while (taskIndex < tasksByOrder.length) {
    const completed = isTaskCompleted(
      gamificationProfile,
      tasksByOrder[taskIndex],
      1,
    );
    if (completed) {
      taskIndex += 1;
    } else {
      return taskIndex;
    }
  }
  return taskIndex;
};
